export default __webpack_public_path__ + "static/media/logo.644013a0.svg";